// extracted by mini-css-extract-plugin
export default {"tooltip":"MW-z","arrow":"NW-z"};